module.exports = __webpack_public_path__ + "img/full1-min.6f6dfd0d.png";